<ng-container *hasPermission="['DEVICES_READ', 'DEVICES_ALL','SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Dettaglio palmare - <b>{{detail_title}}</b></h2>
        </div>
        <form name="organizationForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row">
                <div class="col-md-6 position-relative">
                    <label for="name" class="form-label">Chiava accoppiamento</label> <i
                        class="fa-solid fa-qrcode ms-3 cursor-pointer" *ngIf="device.id != undefined"
                        (click)="showQrcode()"></i>
                    <input type="text" class="form-control" id="id" name="id" ngModel #id="ngModel" [readOnly]="!isNew"
                        [(ngModel)]="device.id" required />
                    <div #canvas class="qrCode"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 ">
                    <label for="name" class="form-label">Name</label>
                    <input type="text" class="form-control" id="name" name="name" ngModel #name="ngModel"
                        [(ngModel)]="device.name" required />

                </div>
                <div class="col-md-6">
                    <label for="organizationId" class="form-label">Ente</label>
                    <select class="form-select" aria-label="Province" id="organizationId" name="organizationId"
                        [(ngModel)]="device.organizationId" required>
                        <option selected value="0">Seleziona ente</option>
                        <option *ngFor="let organization of organizations" [value]="organization.id">
                            {{organization.name+ " - "+organization.cityName}}
                        </option>
                    </select>

                </div>

            </div>
            <div class="d-flex justify-content-end  align-items-center mt-2 gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>

                <ng-template [hasPermission]="['DEVICES_DELETE', 'DEVICES_ALL','SAFESTREET_ADMIN']">
                    @if (this.id !== undefined) {
                    <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                        Elimina
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['DEVICES_UPDATE', 'DEVICES_ALL','SAFESTREET_ADMIN']">
                    @if (this.id !== undefined) {
                    <button type="button" (click)="confirmReset()" class="btn btn-outline-danger">
                        Reset
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['DEVICES_UPDATE', 'DEVICES_ALL','SAFESTREET_ADMIN']"> 
                    @if (this.id !== undefined && (device.paringDate === undefined || device.paringDate === null)) {
                    <button type="button"  (click)="pairing()" class="btn btn-primary">
                        Accoppia
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['DEVICES_UPDATE', 'DEVICES_ALL','SAFESTREET_ADMIN']">
                    @if (this.id !== undefined) {

                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['DEVICES_CREATE', 'DEVICES_ALL','SAFESTREET_ADMIN']">
                    @if (this.id=== undefined) {
                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                    }

                </ng-template>


            </div>
        </form>
        <app-confirm-alert [confirmationMessage]="confirmationMessage"
            [showConfirmationModal]="showConfirmationModal" (modalConfirm)="modalOperationExec()" (modalCancel)="cancelModalOperationExec()">
        </app-confirm-alert>
    </div>
</ng-container>